import { cn } from "@/lib/utils"

/**
 * A nav item's count. Beside the label in the full sidebar; in the icon rail,
 * where there is no room for a number, a dot on the icon's corner instead.
 */
export function SidebarNavBadge({
  count,
  tone = "primary",
}: {
  count: number
  /** "soft" is the tinted pill Leads uses for a running total rather than a to-do. */
  tone?: "primary" | "destructive" | "soft"
}) {
  if (count <= 0) return null
  return (
    <>
      <span
        className={cn(
          "ml-auto flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[10px] font-medium group-data-[collapsible=icon]:hidden",
          tone === "primary" && "bg-primary text-primary-foreground",
          tone === "destructive" && "bg-destructive text-destructive-foreground",
          tone === "soft" && "bg-primary/10 text-primary",
        )}
      >
        {tone !== "soft" && count > 99 ? "99+" : count}
      </span>
      {tone !== "soft" && (
        <span
          aria-hidden
          className={cn(
            "absolute right-1 top-1 hidden h-2 w-2 rounded-full ring-2 ring-sidebar group-data-[collapsible=icon]:block",
            tone === "destructive" ? "bg-destructive" : "bg-primary",
          )}
        />
      )}
    </>
  )
}
